<template>
  <div class="m-0" v-if="isFormationFlyingMission">
    <div
      v-if="!displayResult"
      class="d-inline-flex justify-center align-center"
    >
      <span class="headline grey--text">{{
        currentMission.name.toUpperCase()
      }}</span>
    </div>
    <v-spacer></v-spacer>
    <div class="text-xs-center" v-if="displayComputationWidget">
      <exo-mission-computation> </exo-mission-computation>
    </div>

    <div v-if="displayResult">
      <v-row>
        <v-container class="pb-3">
          <v-row no-gutters>
            <v-col>
              <div class="d-inline-flex justify-center align-center">
                <span class="headline grey--text">{{
                  currentMission.name.toUpperCase()
                }}</span>
                <!-- <exo-help-dialog
                  icon-scale="1.5"
                  title="Formation Flying Simulation Results"
                >
                <p>
                </p>
                </exo-help-dialog> -->
              </div>
            </v-col>
            <v-tooltip bottom v-if="ephemeridesAvailable">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="addPlotConfiguration()"
                >
                  <icon
                    scale="1.5"
                    class="primary--text"
                    name="regular/chart-bar"
                  ></icon>
                </v-btn>
              </template>
              <span>Add plot</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="saveLayout()"
                >
                  <icon scale="1.5" class="primary--text" name="save"></icon>
                </v-btn>
              </template>
              <span
                >Save the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  icon
                  color="primary"
                  v-on="on"
                  @click.stop="dashboardTools().resetLayout(_self)"
                >
                  <icon
                    scale="1.5"
                    class="primary--text"
                    name="undo-alt"
                  ></icon>
                </v-btn>
              </template>
              <span
                >Reset the layout and the configurations of the dashboard</span
              >
            </v-tooltip>
          </v-row>
        </v-container>
      </v-row>
      <v-divider class="mt-0"></v-divider>
      <div class="px-3">
        <numerical-plot-config
          ref="plotConfig"
          v-if="currentResultsLog.results.ephemerides != null"
        ></numerical-plot-config>
        <grid-layout
          :layout.sync="gridlayout"
          :col-num="12"
          :row-height="7"
          :is-draggable="true"
          :is-resizable="true"
          :is-mirrored="false"
          :vertical-compact="true"
          :margin="[20, 10]"
          :use-css-transforms="true"
        >
          <grid-item
            :x="gridlayout[0].x"
            :y="gridlayout[0].y"
            :w="gridlayout[0].w"
            :h="gridlayout[0].h"
            :i="gridlayout[0].i"
            :minH="5"
            :minW="1"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#2A94DE"
              awesomeicon="tachometer-alt"
              title="ΔV"
              :ref="`${statsCardName}${gridlayout[0].i}`"
              :cardId="`${statsCardName}${gridlayout[0].i}`"
              :value="computeResultToDisplay(['maneuverReport', 'totalDeltaV'])"
              :unit="getResultUnitLabel(['maneuverReport', 'totalDeltaV'])"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[1].x"
            :y="gridlayout[1].y"
            :w="gridlayout[1].w"
            :h="gridlayout[1].h"
            :i="gridlayout[1].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#FF7E0D"
              icon="ev_station"
              title="Used propellant"
              :ref="`${statsCardName}${gridlayout[1].i}`"
              :cardId="`${statsCardName}${gridlayout[1].i}`"
              :value="
                computeResultToDisplay(['maneuverReport', 'totalConsumption'])
              "
              :unit="getResultUnitLabel(['maneuverReport', 'totalConsumption'])"
            />
          </grid-item>
          <grid-item
            :x="gridlayout[2].x"
            :y="gridlayout[2].y"
            :w="gridlayout[2].w"
            :h="gridlayout[2].h"
            :i="gridlayout[2].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#38AD38"
              icon="timelapse"
              title="Thrust duration"
              :ref="`${statsCardName}${gridlayout[2].i}`"
              :cardId="`${statsCardName}${gridlayout[2].i}`"
              :value="
                computeResultToDisplay(['maneuverReport', 'totalBurnsDuration'])
              "
              :unit="
                getResultUnitLabel(['maneuverReport', 'totalBurnsDuration'])
              "
            />
          </grid-item>
          <grid-item
            :x="gridlayout[3].x"
            :y="gridlayout[3].y"
            :w="gridlayout[3].w"
            :h="gridlayout[3].h"
            :i="gridlayout[3].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
            <stats-card
              color="#F72C2C"
              icon="timer"
              title="Mission duration"
              :ref="`${statsCardName}${gridlayout[3].i}`"
              :cardId="`${statsCardName}${gridlayout[3].i}`"
              :value="
                computeResultToDisplay(['maneuverReport', 'simulationDuration'])
              "
              :unit="
                getResultUnitLabel(['maneuverReport', 'simulationDuration'])
              "
            />
          </grid-item>

          <grid-item
            :x="gridlayout[4].x"
            :y="gridlayout[4].y"
            :w="gridlayout[4].w"
            :h="gridlayout[4].h"
            :i="gridlayout[4].i"
            :minH="5"
            drag-ignore-from=".no-drag"
          >
            <v-row style="width: 100%; justify-content: center"
              ><div
                id="plotDivTrajectory"
                style="width: 100%; height: 100%"
                class="no-drag"
              ></div>
            </v-row>
            <v-row> </v-row>
          </grid-item>
          <grid-item
            :x="gridlayout[8].x"
            :y="gridlayout[8].y"
            :w="gridlayout[8].w"
            :h="gridlayout[8].h"
            :i="gridlayout[8].i"
            :minH="5"
            @resized="statsCardResized"
            @resize="statsCardResized"
          >
          <v-col
              fill-height
              d-flex
            >
              <results-card :root="_self">
                <v-btn
                  text
                  outlined
                  color="green"
                  v-if="isEphemeridesFilesGenerated"
                  v-on:click="exportEphemeridesFiles()"
                >
                  DOWNLOAD FILES
                </v-btn>
              </results-card>
            </v-col>
          </grid-item>
          <div v-for="(config, index) in configurations" :key="config.id">
            <grid-item
              v-if="config.gridItem"
              :x="config.gridItem.x"
              :y="config.gridItem.y"
              :w="config.gridItem.w"
              :h="config.gridItem.h"
              :i="config.gridItem.i"
              :isDraggable="config.isDraggable"
              @resize="plotCardResized"
              @resized="plotCardResized"
            >
              <v-card tile height="100%">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      @click.stop="
                        dashboardTools().editPlotConfiguration(_self, index)
                      "
                      left
                      dark
                      text
                    >
                      <v-icon dark medium>edit</v-icon>
                      Edit
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click.stop="
                        dashboardTools().removePlotConfiguration(
                          _self,
                          config.gridItem.i
                        )
                      "
                      left
                      dark
                      text
                    >
                      <v-icon dark medium>delete</v-icon>
                      Delete
                    </v-btn>
                  </v-col>
                </v-row>
                <plot-item
                  :gridlayout="gridlayout"
                  height="100%"
                  :root="_self"
                  :config="config"
                  :id="`${plotingAreaName}${config.gridItem.i}`"
                  :ref="`${plotingAreaName}${config.gridItem.i}`"
                  class="elevation-5"
                >
                </plot-item>
              </v-card>
            </grid-item>
          </div>
        </grid-layout>
      </div>
    </div>
  </div>
</template>

<script>
import resultsDescription from '../../tools/resultsDescription.json'
import dashboardComponents from '../../components/Dashboard/index.js'
import dataTools from '../../tools/data.js'
import dashboardTools from '../../tools/dashboard.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import plotInput from '../../mixins/plotInput.js'
import plotLayout from '../../mixins/plotLayout.js'
import plotData from '../../mixins/plotData.js'
import Plotly from 'plotly.js-dist'
import errorMixin from '../../mixins/logHandler.js'
import { setTimeout } from 'timers'

Vue.use(dashboardComponents)

export default {
  name: 'FormationFlyingSimulationDashboard',
  mixins: [errorMixin, plotLayout, plotInput, plotData],
  data() {
    const self = this
    return {
      configurations: [],
      isDrawn: [],
      configuration: null,
      type: 'SimulationResult',
      plotingAreaName: 'plotingAreaNumerical',
      statsCardName: 'statsCard',
      defaultLayout: [
        { x: 0, y: 0, w: 2, h: 6, i: '0' },
        { x: 2, y: 0, w: 2, h: 6, i: '1' },
        { x: 4, y: 0, w: 2, h: 6, i: '2' },
        { x: 6, y: 0, w: 2, h: 6, i: '3' },
        { x: 0, y: 1, w: 8, h: 28, i: '4' },
        { x: 0, y: 2, w: 4, h: 28, i: '5' },
        { x: 8, y: 0, w: 4, h: 28, i: '6' },
        { x: 4, y: 3, w: 4, h: 28, i: '7' },
        { x: 8, y: 0, w: 2, h: 22, i: '8' }
      ],
      gridlayout: [
        { x: 0, y: 0, w: 2, h: 6, i: '0' },
        { x: 2, y: 0, w: 2, h: 6, i: '1' },
        { x: 4, y: 0, w: 2, h: 6, i: '2' },
        { x: 6, y: 0, w: 2, h: 6, i: '3' },
        { x: 0, y: 1, w: 8, h: 28, i: '4' },
        { x: 0, y: 2, w: 4, h: 28, i: '5' },
        { x: 8, y: 0, w: 4, h: 28, i: '6' },
        { x: 4, y: 3, w: 4, h: 28, i: '7' },
        { x: 8, y: 0, w: 2, h: 22, i: '8' }
      ],

      plotConfig: { responsive: true }
    }
  },

  created() {
    window.addEventListener('beforeunload', this.saveLayout)
  },

  mounted() {
    this.$root.$on('current-results-updated', this.currentResultsUpdatedHandler)

    setTimeout(() => {
      this.loadLayout()
    }, 1000)

    this.$root.$on('create-plot', this.createPlotHandler)
  },

  beforeDestroy() {
    this.cleanPlots()
    this.$root.$off(
      'current-results-updated',
      this.currentResultsUpdatedHandler
    )
    this.$root.$off('create-plot', this.createPlotHandler)
  },

  computed: {
    ...mapGetters(['currentUser', 'currentMission', 'currentResultsLog']),
    displayComputationWidget() {
      return this.computationNeeded || !this.resultsLoaded
    },
    displayResult() {
      return this.resultsLoaded && !this.computationNeeded
    },
    computationNeeded() {
      return (
        this.currentMission &&
        this.currentMission.computationRequested &&
        this.currentMission.computationLogId === ''
      )
    },
    isEphemeridesFilesGenerated() {
      if (this.currentResultsLog.results.ephemeridesFiles != null) {
        return (
          Object.keys(this.currentResultsLog.results.ephemeridesFiles).length >
          0
        )
      } else {
        return false
      }
    },
    resultsLoaded() {
      return (
        this.currentResultsLog != null && this.currentResultsLog.results != null
      )
    },
    isFormationFlyingMission() {
      return (
        this.currentMission != null &&
        this.currentMission.typeName === 'SimulationRequest' &&
        this.currentMission.type === 'Formation flying'
      )
    },
    resultAvailable() {
      return (
        this.isFormationFlyingMission &&
        this.resultsLoaded &&
        this.currentResultsLog.results ===
          Object(this.currentResultsLog.results)
      ) // check object, not array
    },
    ephemeridesAvailable() {
      return (
        this.resultAvailable &&
        this.currentResultsLog.results.ephemerides != null
      )
    }
  },

  methods: {
    currentResultsUpdatedHandler() {
      this.loadLayout()
      setTimeout(() => {
        this.resizeAllStatsCardResized()
      }, 200)
    },
    exportEphemeridesFiles() {
      let files = this.currentResultsLog.results.ephemeridesFiles
      Object.entries(files).forEach((entry) => {
        let key = entry[0]
        let value = entry[1]
        const filename = this.currentMission.name + '_' + key
        dataTools.downloadFile(filename, value.join(''), 'txt', false) // no utf8
      })
    },
    createPlotHandler(config, plotingArea, fromLayoutSave) {
      if (!fromLayoutSave && config.layout) {
        config.gridItem.h = 25
      }
      // Use timeout as workaround because nextTick doesnt work as expected
      setTimeout(() => {
        let el = this.$refs[`${this.plotingAreaName}${config.gridItem.i}`]
        if (el) {
          el = el[0]
          let parent = el ? el.$parent : undefined
          if (parent) {
            config.layout.height = parent.$el.clientHeight - 50
            if (config.data.length > 0) {
              if (
                config.data[0].x
                  .filter((data) => !isNaN(data) || typeof data === 'string')
                  .some(isNaN)
              ) {
                config.layout.xaxis.categoryorder = 'array'
                config.layout.xaxis.categoryarray = [...config.data[0].x] // to create a new array
                config.layout.xaxis.categoryarray.sort()
              }
              if (
                config.data[0].y
                  .filter((data) => !isNaN(data) || typeof data === 'string')
                  .some(isNaN)
              ) {
                config.layout.yaxis.categoryorder = 'array'
                config.layout.yaxis.categoryarray = [...config.data[0].y] // to create a new array
                config.layout.yaxis.categoryarray.sort()
              }
              Plotly.react(plotingArea, config.data, config.layout, {
                responsive: true
              })
              plotingArea.addEventListener('mouseover', (data) => {
                config.isDraggable = false
              })
              plotingArea.addEventListener('mouseleave', (data) => {
                config.isDraggable = true
              })
            }
          }
        }
      }, 100)
    },

    addDefaultAxis(axisList, condition, name) {
      if (condition) {
        let parameter = this.buidDefaultPlotParameter()
        parameter.value = name
        this.treeUpdated(parameter, 'parameter')
        axisList.push(parameter)
      }
    },
    cleanPlots() {
      try {
        Plotly.purge('plotDivTrajectory')
      } catch (e) {}
    },
    addDefaultPlots() {
      this.configurations = []
      this.configuration = this.buildEmptyConfiguration(0)
      this.buildVelocityRadialPlot()
      this.buildTimeVelocityPlot()
      this.buildAlongTrackOffPlanePlot()
    },

    buildVelocityRadialPlot() {
      let config = this.buildEmptyConfiguration(0)
      config.name = 'Along-track over radial position error'
      config.type = 'Line/Scatter chart'
      config.scatterMode = 'markers'
      config.x.value = 'positionErrorInVelocityDirection'
      this.treeUpdated(config.x, 'x')
      config.y.value = 'positionErrorInRadialDirection'
      this.treeUpdated(config.y, 'y')

      let gridItem = this.gridlayout[4]
      config.id = 0
      config.gridItem = gridItem
      this.configuration = config
      this.configurations.push(config)
      this.gridlayout.push(this.configuration.gridItem)
      this.$nextTick(() => {
        let plotingArea = document.getElementById(
          `${this.plotingAreaName}${this.configuration.gridItem.i}`
        )
        if (plotingArea != null) {
          this.$root.$emit('set-plot-config', this.configuration, plotingArea)
        }
        this.basicPlotLoadWorkaround()
      })
    },

    buildTimeVelocityPlot() {
      let config = this.buildEmptyConfiguration(0)
      config.name = 'Position error in velocity direction over time'
      config.type = 'Line/Scatter chart'
      config.scatterMode = 'lines'
      config.x.value = 'simulationDuration'
      this.treeUpdated(config.x, 'x')
      config.y.value = 'position.ErrorInVelocityDirection'
      this.treeUpdated(config.y, 'y')

      let gridItem = this.gridlayout[5]
      config.id = 1
      config.gridItem = gridItem
      this.configuration = config
      this.configurations.push(config)
      this.gridlayout.push(this.configuration.gridItem)
      this.$nextTick(() => {
        let plotingArea = document.getElementById(
          `${this.plotingAreaName}${this.configuration.gridItem.i}`
        )
        if (plotingArea != null) {
          this.$root.$emit('set-plot-config', this.configuration, plotingArea)
        }
        this.basicPlotLoadWorkaround()
      })
    },

    buildAlongTrackOffPlanePlot() {
      let config = this.buildEmptyConfiguration(0)
      config.name = 'Along-track out of plane position error'
      config.type = 'Line/Scatter chart'
      config.scatterMode = 'markers'
      config.x.value = 'position.ErrorInVelocityDirection'
      this.treeUpdated(config.x, 'x')
      config.y.value = 'position.ErrorInOffPlaneDirection'
      this.treeUpdated(config.y, 'y')

      let gridItem = this.gridlayout[7]
      config.id = 2
      config.gridItem = gridItem
      this.configuration = config
      this.configurations.push(config)
      this.gridlayout.push(this.configuration.gridItem)
      this.$nextTick(() => {
        let plotingArea = document.getElementById(
          `${this.plotingAreaName}${this.configuration.gridItem.i}`
        )
        if (plotingArea != null) {
          this.$root.$emit('set-plot-config', this.configuration, plotingArea)
        }
        this.basicPlotLoadWorkaround()
      })
    },

    // basicPlotLoadWorkaround is a function to handle the fact that plots may spawn at the bottom of the page
    // Unfortunately, we can't resolve it the proper way until we make some cleaning in the event bus ¯\_( ͡° ͜ʖ ͡°)_/¯
    basicPlotLoadWorkaround() {
      let grid = this.gridlayout
      let newGrid = []
      grid.forEach((el) => {
        let exists = newGrid.find((elB) => {
          return elB.i === el.i
        })
        if (!exists) {
          newGrid.push(el)
        }
      })
      this.gridlayout = newGrid
      let plot0Conf = this.configurations.find(
        (el) => el.gridItem.i === 'plot0'
      )
      if (plot0Conf != null) {
        plot0Conf.gridItem = this.gridlayout.find((el) => el.i === 'plot0')
      }
    },

    dashboardTools() {
      return dashboardTools
    },
    saveLayout() {
      dashboardTools.saveLayout(this)
    },
    loadLayout() {
      if (this.currentMission) {
        if (this.currentMission.layout) {
          let missionLayout = JSON.parse(this.currentMission.layout)
          dataTools.loadGridLayoutConfig(missionLayout, this)
        } else {
          let missionLayout = { configurations: [], layout: this.defaultLayout }
          dataTools.loadGridLayoutConfig(missionLayout, this)
          if (
            !this.currentResultsLog ||
            !this.currentResultsLog.results ||
            !this.currentResultsLog.results.fieldIndexes ||
            !this.currentResultsLog.results.ephemerides
          ) {
            return
          }
          this.addDefaultPlots()
        }
      }
      dashboardTools.removeDuplicatedGridItem(this)
    },
    resizeAllStatsCardResized() {
      this.statsCardResized(0)
      this.statsCardResized(1)
      this.statsCardResized(2)
      this.statsCardResized(3)
    },

    statsCardResized(i) {
      return dashboardTools.statsCardResized(this, i)
    },

    plotCardResized(i, newH, newW, newHPx, newWPx) {
      let update = {
        width: newWPx,
        height: newHPx - 50 // TODO find a better way to get this value
      }
      let plotingArea = document.getElementById(`${this.plotingAreaName}${i}`)
      if (plotingArea != null) {
        try {
          Plotly.relayout(plotingArea, update)
        } catch (e) {
          console.log('Error calling Plotly.relayout')
        }
      }
    },

    getResultFieldType(field) {
      return resultsDescription.SimulationResult[field].type
    },

    getResultUnitLabel(fieldPath) {
      return dashboardTools.getResultUnitLabel(this, fieldPath)
    },

    buildPath(path) {
      if (!this.resultAvailable) {
        return
      }
      let field = this.currentResultsLog.results
      for (let i = 0; i < path.length; i++) {
        field = field[path[i]]
      }
      return field
    },

    computeResultToDisplay(fieldPath) {
      let fieldType = dataTools.getFieldTypeFromPath(fieldPath, this.type, null)
      if (
        this.resultAvailable != null &&
        this.currentResultsLog.results != null
      ) {
        return dataTools.convertSi2Display(
          fieldType,
          dataTools.getValue(this.currentResultsLog.results, fieldPath)
        )
      } else {
        return ''
      }
    },

    getCurrentAPI() {
      if (this.currentMission) {
        return dashboardTools.getAPI(this, 'formationflyingsimulationrequests')
      }
    },

    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    },

    addPlotConfiguration() {
      dashboardTools.removeDuplicatedGridItem(this)

      let lastId =
        this.configurations.length > 0
          ? this.configurations.reduce((acc, curr) => {
              return curr.id > acc.id ? curr : acc
            }).id
          : 0
      let newId = lastId + 1
      let newConfig = this.buildEmptyConfiguration(newId)
      this.configuration = newConfig
      let biggestY = this.gridlayout.reduce((acc, curr) => {
        return acc.y > curr.y ? acc : curr
      }, this.gridlayout[0])
      let gridItem = {
        x: 0,
        y: biggestY.y + biggestY.h,
        w: 4,
        h: 25,
        i: `${'plot' + newId}`
      }
      this.configuration.gridItem = gridItem
      this.configurations.push(this.configuration)
      this.$nextTick(() => {
        this.gridlayout.push(this.configuration.gridItem)
        this.$nextTick(() => {
          let plotingArea = document.getElementById(
            `${this.plotingAreaName}${this.configuration.gridItem.i}`
          )
          if (plotingArea != null) {
            this.$root.$emit('set-plot-config', this.configuration, plotingArea)
          }
          this.$refs.plotConfig.drawer = !this.$refs.plotConfig.drawer
        })
      })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>
